/** Server-generated CSV exports, one `type` per screen. */
import { endpoints } from '@/config/env';
import type { DateRange } from '@/lib/dateRange';
import { requestBlob } from './client';

/** The `type` query value the export endpoint expects, per screen. */
export type ExportType = 'return' | 'exchange' | 'refunds' | 'qc_queue' | 'exceptions' | 'BLOCKLIST';

/** Optional status filter to scope the export to a single status (or comma-separated set). */
export interface ExportStatusFilter {
  status?: string;
  statuses?: string;
}

export function fetchExportCsv(
  type: ExportType,
  range: DateRange,
  filter: ExportStatusFilter = {},
  signal?: AbortSignal,
): Promise<Blob> {
  return requestBlob(
    endpoints.analyticsExport({
      from: range.from,
      to: range.to,
      type,
      status: filter.status,
      statuses: filter.statuses,
    }),
    signal,
  );
}
